module.exports = __webpack_public_path__ + "img/trusted-icon.85bace1f.png";